import React from 'react';
import { exerciseStructure, photos, sampleMeta, sampleRows } from '../data/content';
import { OfferLink } from './ui/OfferLink';
import { Eyebrow, Mark, SectionTitle } from './ui/Section';
export function LookInside() {
  return <section className="bg-canvas px-4 py-12 md:py-16" data-id="element-114" data-mp="21m959k1bsu8e">
      <div className="mx-auto max-w-6xl" data-id="element-115" data-mp="25och49rwq0u7">
        <Eyebrow data-id="element-116" data-mp="25n1c66mq6n1i">Look inside</Eyebrow>
        <SectionTitle data-id="element-117" data-mp="1rx7o3qj1o6su">
          What you get <Mark data-id="element-118" data-mp="1rwxzo7dne7p9">inside each exercise</Mark>
        </SectionTitle>

        <div className="mt-8 grid items-center gap-8 lg:grid-cols-5" data-id="element-119" data-mp="1wnxtv4vdubo2">
          <OfferLink className="mx-auto w-full max-w-xs lg:col-span-2" label="See the Complete Injury Rehabilitation Bundle offer" data-id="element-120" data-mp="1wp8x93kx1hen">
            <img src={photos.bandRotation} alt="Adult performing a band external rotation with the elbow close to the body" className="aspect-[4/5] w-full rounded-3xl object-cover shadow-xl transition-transform duration-300 ease-out group-hover:scale-[1.01]" data-id="element-121" data-mp="1mxv2ta7tn7sd" />
          </OfferLink>

          <article className="overflow-hidden rounded-2xl border border-navy/10 bg-white shadow-xl lg:col-span-3" data-id="element-122" data-mp="a1mp49zvostc">
            <header className="bg-navy p-5" data-id="element-123" data-mp="60jatrxhb4u8">
              <p className="text-[10px] font-extrabold uppercase tracking-wider text-brand-light" data-id="element-124" data-mp="k0lspe5sdy9h">Sample exercise</p>
              <h3 className="mt-1 font-display text-base font-black uppercase text-white md:text-lg" data-id="element-125" data-mp="f1hj4mey9yim">
                Band External Rotation
              </h3>
            </header>
            <dl className="grid gap-px bg-navy/10 sm:grid-cols-3" data-id="element-126" data-mp="3iirc4wf1hq57">
              {sampleMeta.map(([label, value]) => <div key={label} className="bg-white p-4" data-id="element-127" data-mp="129g1ifo2695">
                  <dt className="text-[10px] font-extrabold uppercase tracking-wider text-steel" data-id="element-128" data-mp="13t0ll8cv3gq">{label}</dt>
                  <dd className="mt-0.5 text-sm font-bold text-navy" data-id="element-129" data-mp="34r316wgj17pt">{value}</dd>
                </div>)}
            </dl>
            <div className="border-t border-navy/10 px-5 py-1" data-id="element-130" data-mp="2zqyjx47so8yj">
              <table className="w-full text-left text-sm" data-id="element-131" data-mp="13ov4pwdfsl7t">
                <tbody data-id="element-132" data-mp="13obvd41ur55e">
                  {sampleRows.map(([label, value]) => <tr key={label} className="border-b border-navy/10 last:border-b-0" data-id="element-133" data-mp="18mn7jlfmdrqs">
                      <th scope="row" className="w-32 py-2.5 pr-3 align-top text-[10px] font-extrabold uppercase tracking-wider text-brand" data-id="element-134" data-mp="1dfprr2yiboub">
                        {label}
                      </th>
                      <td className="py-2.5 font-semibold text-navy" data-id="element-135" data-mp="pospkhwik5w9">{value}</td>
                    </tr>)}
                </tbody>
              </table>
            </div>
            <div className="border-t border-navy/10 bg-canvas px-5 py-4" data-id="element-136" data-mp="ypqwb7yc6rij">
              <p className="font-display text-[11px] font-black uppercase tracking-wider text-navy" data-id="element-137" data-mp="yr1xd00edl5y">
                Every exercise includes:
              </p>
              <ul className="mt-2 flex flex-wrap gap-1.5" data-id="element-138" data-mp="2a44ebw6escqn">
                {exerciseStructure.map(item => <li key={item} className="rounded-md border border-navy/10 bg-white px-2 py-1 text-[10px] font-bold uppercase tracking-wide text-steel" data-id="element-139" data-mp="2k7j8lr58xoyh">
                    {item}
                  </li>)}
              </ul>
            </div>
          </article>
        </div>
      </div>
    </section>;
}